// extracted by mini-css-extract-plugin
export const root = "layout-module--root--hUzat";